import {
    isPlayerAction,
    Projection,
    SharedGameState,
    useGameStore,
} from '@glark-newco/game-library';
import {shallow} from 'zustand/shallow';
import {
    isAssignPlayerNodePayload,
    RingDefinition,
    RingId,
} from '../SupplyChainPayloadTypes';

export type RingDefinitionsMap = Record<RingId, RingDefinition>;

export interface RingDefinitionsSlice extends SharedGameState {
    ringDefinitions?: RingDefinitionsMap;
}

export const ringDefinitionsProjection: Projection<RingDefinitionsSlice> = {
    name: 'ringDefinitionsProjection',
    project: (state, newEvents) => {
        const definitions = {...(state.ringDefinitions ?? {})};
        let modified = false;

        newEvents.forEach(ev => {
            if (isPlayerAction(ev) && isAssignPlayerNodePayload(ev.payload)) {
                const assign = ev.payload;
                assign.rings.forEach(ring => {
                    definitions[ring.ringId] = ring;
                });
                modified = true;
            }
        });

        return modified ? {ringDefinitions: definitions} : {};
    },
    reset: () => ({
        ringDefinitions: {},
    }),
};

export const useRingDefinitions = () =>
    useGameStore((s: RingDefinitionsSlice) => s.ringDefinitions) ?? {};

export const useRingDefinition = (ringId: RingId | undefined): RingDefinition | undefined => {
    return useGameStore(
        (s: RingDefinitionsSlice) => s.ringDefinitions?.[ringId ?? 'undefined'],
        shallow,
    );
};
